console.log(`Node Env: ${process.env.NODE_ENV}, Platform: ${process.env.REACT_APP_PLATFORM}`);
export const app = {
  // URL:'http://localhost:3200'
  
  // URL:'http://192.168.100.99:3200'
  URL: process.env.REACT_APP_PLATFORM === 'production' ? process.env.REACT_APP_PRODUCTION : process.env.REACT_APP_PLATFORM === 'staging' ? process.env.REACT_APP_STAGING : process.env.REACT_APP_PRODUCTION,
  // URL: 'https://websitestagging.know.us',
};
